





























































import Vue, {VueConstructor} from 'vue'
import Message from '@/models/Message/Message'
import { HIDE_MESSAGE_INPUT } from '@/constants';
import config from '@/config'
import messageCom from './msg.vue'
import luxon from 'luxon'
import {Dictionary} from 'vuex'
import _ from 'lodash'
// @ts-ignore
import EmojiPicker from '@/components/EmojiPicker/EmojiPicker'
export default (Vue as VueConstructor<Vue & {
  $refs: {
    container: HTMLElement,
    scrollbar: {
      setScrollTop: (val: number) => void,
      refresh: () => void,
      $refs: {
        content: HTMLElement
      }
    },
    group: HTMLElement[]
  }
}>).extend({
  components: {
    messageCom,
    EmojiPicker
  },
  props: {
    list: Array as () => Message[],
    stubText: String,
    disabled: Boolean,
    defaultHeight: {
      type: Number,
      default: 600
    },
    draggable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      messageText: '',
      isInputFocused: false,
      isInputDisabled: false,
      visibleGropus: {} as Dictionary<Message[]>,
      containerHeight: 0,
      currentDate: '',
      currentDateVis: false,
      height: 0,
      HIDE_MESSAGE_INPUT: config(HIDE_MESSAGE_INPUT)
    }
  },
  methods: {
    // @ts-ignore
    onPickEmoji (emoji) {
      this.messageText += `${emoji}`;
    },
    onInputFocus () {
      this.isInputFocused = true
    },
    onInputBlur () {
      this.isInputFocused = false
    },
    onScrollUp (event: UIEvent) {
      this.$emit('onScrollUp')
    },
    onScroll (event: UIEvent) {
      this.setVisibleGroups()
      const visG = this.getVisibleGroups()
      this.setCurrentDay(visG)
      this.currentDateVis = true;
    },
    setInputDisabled (val: boolean) {
      this.isInputDisabled = !!val
    },
    getScrollTop (): number {
      return this.$refs.scrollbar.$refs.content.scrollTop
    },
    setCurrentDay (visG: Dictionary<Message[]>): void {
      if (Object.keys(visG).length) {
        const first = Object.keys(visG)[0]
        this.currentDate = visG[first][0].getSendDate('dd.LL.yyyy')
      }
    },
    getVisibleGroups (): Dictionary<Message[]> {
      return this.visibleGropus
    },
    setVisibleGroups (): void {
      const upBorder = this.getScrollTop()
      const downBorder = this.getScrollTop() + this.$refs.scrollbar.$refs.content.clientHeight
      const groups = this.$refs.group
      const visibleKeys: string[] = []
      const visibleGroups: Dictionary<Message[]> = {}
      groups.forEach(group => {
        const gStart = group.offsetTop
        const gEnd = gStart + group.offsetHeight

        if (gStart < downBorder && gEnd > upBorder) {
          const gKey = group.getAttribute('data-g-key')
          if (gKey) {
            visibleKeys.push(gKey)
          }
        }
      });
      visibleKeys.sort((a, b) => a > b ? 1 : -1);

      for (const key of visibleKeys) {
        const g = this.groups[key]
        if (g) {
          visibleGroups[key] = g
        }
      }
      this.visibleGropus = visibleGroups
    },
    slideScrollToBottom () {
      const pos = this.$refs.scrollbar.$refs.content.scrollHeight - this.$refs.scrollbar.$refs.content.clientHeight
      this.setContentScrollTop(pos);
      this.setCurrentContainerHeight()
    },
    getScrollHeight (): number {
      return this.$refs.scrollbar.$refs.content.scrollHeight
    },
    freezeScroll (prevScrollHeight?: number) {
      // Compensate scroll position after older messages are prepended so the
      // viewport stays visually still. Native scroll anchoring is disabled
      // (overflow-anchor:none) so we are the only owner of scrollTop here —
      // no double-shift, no flicker.
      //
      // The caller captures content.scrollHeight *before* the prepend and
      // passes it in. By now (Vue's $nextTick, a microtask that runs after
      // the DOM patch but before the browser paints) the new messages are in
      // the DOM, so the height delta is exactly how far everything moved
      // down. Adjusting scrollTop in this same pre-paint microtask means the
      // browser only ever paints the corrected position.
      const content = this.$refs.scrollbar.$refs.content
      const diff = typeof prevScrollHeight === 'number'
        ? content.scrollHeight - prevScrollHeight
        : this.$refs.container.clientHeight - this.containerHeight
      if (diff > 0) {
        content.scrollTop = content.scrollTop + diff
      }
      this.setCurrentContainerHeight()
    },
    setContentScrollTop (val: number) {
      this.$refs.scrollbar.setScrollTop(val)
    },
    setCurrentContainerHeight () {
      if (this.$refs.container) {
        this.containerHeight = this.$refs.container.clientHeight;
      }
    },
    onSendClick () {
      const isEmpty = /^\s*$/.test(this.messageText)
      if (!isEmpty && !this.isInputDisabled) {
        this.$emit('input', this.messageText)
      }
    },
    onEnterKeyup (event: any) {
      if (event.keyCode === 13 && event.ctrlKey || event.metaKey) {
        this.onSendClick()
      }
    },
    clearMessageText (): void {
      this.messageText = ''
    },
    hideCurrentDate: _.debounce(function (scrollTop: number) {
      // @ts-ignore
      this.currentDateVis = false;
    }, 1000),
    setHeight (val: number) {
      this.height = val
    },
    onDragged (e: any) {
      if (e.deltaX === undefined) {
        e.deltaX = 0
      }
      if (e.deltaY === undefined) {
        e.deltaY = 0
      }
      this.setHeight(this.height + e.deltaY)
    },
    onWidgetShown () {
      // Parent told us the iframe became visible again. Rebuild Safari's
      // scroll layer / overlay scrollbar. Covers parents that hide via
      // `visibility:hidden` (no size change, so ResizeObserver never fires).
      this.$nextTick(() => {
        if (this.$refs.scrollbar && this.$refs.scrollbar.refresh) {
          this.$refs.scrollbar.refresh()
        }
      })
    }
  },
  computed: {
    map (): Dictionary<Message> {
      let map: Dictionary<Message> = {}
      for (const message of this.list) {
        const id = message.getId()
        if (!map[id]) {
          map[id] = message
        }
      }
      return map;
    },
    groups (): Dictionary<Message[]> {
      let map: Dictionary<Message[]> = {}
      for (const message in this.map) {
        let date = this.map[message].getSendDate('yyyyLLdd')
        if (!map[date]) {
          map[date] = []
        }
        map[date].push(this.map[message])
      }
      return map
    },
    sortedGroupsList (): Message[][] {
      let groupKeys: number[] = []
      for (const key in this.groups) {
        groupKeys.push(Number(key))
      }
      groupKeys.sort((a, b) => a > b ? 1 : -1);

      let sordetList = []
      for (const key of groupKeys) {
        if (this.groups[key]) {
          sordetList.push(this.groups[key])
        }
      }
      return sordetList;
    }
  },
  mounted () {
    this.setHeight(this.defaultHeight)
    setTimeout(() => {
      this.setCurrentContainerHeight()
    }, 500);
    window.addEventListener('keyup', this.onEnterKeyup);
    this.$root.$on('lsn-widget-shown', this.onWidgetShown);
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.onEnterKeyup);
    this.$root.$off('lsn-widget-shown', this.onWidgetShown);
  }
})
